const LOCATION_TYPE_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  isImageDetailsLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  imageDetailsError: undefined,
  data: undefined,
}

export default LOCATION_TYPE_INITIAL_STATE
